import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {ConstantService} from "../services/constant.service";

@Injectable({
  providedIn: 'root'
})
export class CryptojsService {

  constructor() {
  }


  public static encryptData(data: any): any {
    try {
      if (data) {
        return CryptoJS.AES.encrypt(
          JSON.stringify(data),
          ConstantService.ENCRYPT_SECRET_KEY
        ).toString();
      }
    } catch (e) {
      console.error(e);
    }
  }

  public static decryptData(data: any): any{
    try {
      if (data) {
        const bytes = CryptoJS.AES.decrypt(data.toString(), ConstantService.ENCRYPT_SECRET_KEY);
        if (bytes.toString()) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        return data;
      }
    } catch (e) {
      console.error(e);
    }
  }


}
